import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle";
import { forgotPassword } from "../redux/features/loginSlice";
import { useModal } from "../hooks/ModalContext";

const ForgotPasswordModal = ({ isActive, onClose, onVerifyOtp, onResetPassword }) => {
  const dispatch = useDispatch();
  const { forgotPasswordStatus, forgotPasswordError, otpStatus, resetPasswordStatus } =
    useSelector((state) => state.auth);
  const { setEmailForOtp } = useModal();

  const [isProcessActive, setIsProcessActive] = useState(false);
  const modalRef = useRef(null);
  const bsModal = useRef(null);

  // Initialize Bootstrap modal once
  useEffect(() => {
    if (modalRef.current) {
      bsModal.current = bootstrap.Modal.getOrCreateInstance(modalRef.current, {
        backdrop: true,
        keyboard: true,
      });

      modalRef.current.addEventListener("hidden.bs.modal", () => {
        onClose?.();
      });
    }

    return () => {
      modalRef.current?.removeEventListener("hidden.bs.modal", onClose);
      bsModal.current = null;
    };
  }, [onClose]);

  // Control modal visibility via prop
  useEffect(() => {
    if (!bsModal.current) return;

    if (isActive) {
      bsModal.current.show();
      setIsProcessActive(false);
    } else {
      bsModal.current.hide();
    }
  }, [isActive]);

  // Handle flow transitions
  useEffect(() => {
    const modalInstance = bsModal.current;
    if (!modalInstance) return;

    // Forgot Password → Verify OTP
    if (forgotPasswordStatus === "success" && !isProcessActive) {
      setIsProcessActive(true);
      modalInstance.hide();

      modalRef.current.addEventListener(
        "hidden.bs.modal",
        () => {
          onVerifyOtp?.();
        },
        { once: true }
      );
    }

    // OTP → Reset Password
    if (otpStatus === "success" && isProcessActive) {
      modalInstance.hide();

      modalRef.current.addEventListener(
        "hidden.bs.modal",
        () => {
          onResetPassword?.();
          setIsProcessActive(false);
        },
        { once: true }
      );
    }

    // Reset Password → close all
    if (resetPasswordStatus === "success") {
      modalInstance.hide();
      setIsProcessActive(false);
    }
  }, [forgotPasswordStatus, otpStatus, resetPasswordStatus, isProcessActive, onVerifyOtp, onResetPassword]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    // Store for OTP modal
    setEmailForOtp(email);
    dispatch(forgotPassword({ email }));
  };

  return (
    <div className="modal fade" ref={modalRef} tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Forgot Password</h5>
            <button type="button" className="btn-close" onClick={() => bsModal.current?.hide()}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  Email address
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="Enter your email"
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary w-100">
                Send OTP
              </button>
              {forgotPasswordError && <div className="text-danger mt-2">{forgotPasswordError}</div>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
